import clsx from 'clsx'
import React from 'react'
import { createPortal } from 'react-dom'
import { isDesktop } from '../../utils'
import Icon from '../Icon'

import './Modal.scss'

const Modal = ({
   className,
   isOpen,
   close,
   children,
   heading,
   isDarkTheme,
}) => {
   return createPortal(
      <div
         className={clsx(
            'Modal',
            isOpen && !isDesktop() && 'Modal--open',
            className,
            isDarkTheme && 'Modal--dark',
            isDesktop() && 'Modal--desktop',
            isOpen && isDesktop() && 'Modal--open-desktop'
         )}
      >
         <div className="Modal__content">
            <div className="Modal__header">
               <span className="Modal__header-heading">{heading}</span>
               <Icon
                  className="Modal__header-close"
                  name="close"
                  onClick={close}
               />
            </div>
            <div className="Modal__body">{children}</div>
         </div>
      </div>,
      document.getElementById('modal-root')
   )
}

export default Modal
